import { GameState } from '../ski';

export function checkCollisions(gameState: GameState) {
    const skierBox = gameState.skier.getCollisionBox();

    for (const tree of gameState.trees) {
        // Skip decor trees - no collision
        if (tree.isDecor) continue;
        if (tree.hasCollided) continue;

        const treeBox = tree.getCollisionBox();

        // Only check trees that are near the skier's Y level
        if (Math.abs(tree.pos.y - gameState.skier.pos.y) > 60) continue;

        // AABB collision
        if (skierBox.x < treeBox.x + treeBox.width &&
            skierBox.x + skierBox.width > treeBox.x &&
            skierBox.y < treeBox.y + treeBox.height &&
            skierBox.y + skierBox.height > treeBox.y) {

            tree.hasCollided = true;
            gameState.skier.onCollision();
        }
    }
}
